import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import { ContentBlocks } from "./ContentBlocks.js";
import { applyTemplateBlocks, transformBlockTemplate } from "./editor/block-templates.js";
import { blocksByTag } from "./editor/blocks-by-tag.js";
import { useBlockContext, useInnerBlocks } from "./inline-editing.js";
import { hash } from "object-code";
const Appender = ({ config, ...props }) => {
    const clientId = useBlockContext()?.block[1].clientId;
    if (config?.type === "button") {
        return _jsx(wp.blockEditor.ButtonBlockAppender, { ...props, rootClientId: clientId, className: config.className });
    }
    else if (config?.type === "button2") {
        return _jsx(wp.blockEditor.InnerBlocks.ButtonBlockAppender, {});
    }
    else if (config?.type === "simple") {
        return (_jsx(wp.blockEditor.ButtonBlockAppender, { ...props, rootClientId: clientId, className: (props.className || "") + " block-editor-inserter__toggle has-icon simple-appender" }));
    }
    else if (typeof config?.type === "function") {
        const Type = config?.type;
        return (_jsx(wp.blockEditor.Inserter, { rootClientId: clientId, renderToggle: (p) => {
                return _jsx(Type, { ...p });
            }, isAppender: true, disabled: false }));
        // } else if (config?.type === "simple") {
        //   return (
        //     <wp.blockEditor.Inserter
        //       clientId={clientId}
        //       rootClientId={clientId}
        //       renderToggle={(p: any) => {
        //         return (
        //           <button
        //             className="simple-appender components-button block-editor-inserter__toggle !inline-flex has-icon"
        //             onClick={() => p.onToggle()}
        //           >
        //             <svg
        //               xmlns="http://www.w3.org/2000/svg"
        //               viewBox="0 0 24 24"
        //               width="24"
        //               height="24"
        //               aria-hidden="true"
        //               focusable="false"
        //             >
        //               <path d="M11 12.5V17.5H12.5V12.5H17.5V11H12.5V6H11V11H6V12.5H11Z"></path>
        //             </svg>
        //           </button>
        //         )
        //       }}
        //       isAppender
        //       // @ts-ignore
        //       __experimentalIsQuick
        //     />
        //   )
    }
    else {
        // @ts-ignore
        return _jsx(wp.blockEditor.InnerBlocks.DefaultBlockAppender, { ...props });
    }
};
export function createAppender(comp) {
    return {
        type: comp,
    };
}
/**
 * Allows child blocks to be added to the current block context.
 */
export function InnerBlocks(props) {
    if (env.admin) {
        const inlineContext = useBlockContext();
        const appender = useMemo(() => {
            return (p) => _jsx(Appender, { config: props.appender, ...p });
        }, [props.appender]);
        if (!inlineContext?.readonly) {
            const innerBlocksProps = wp.blockEditor.useInnerBlocksProps({}, {
                orientation: props.orientation ?? "vertical",
                allowedBlocks: props.allowedBlocks ? blocksByTag.expand(props.allowedBlocks) : undefined,
                prioritizedInserterBlocks: props.prioritizedInserterBlocks,
                renderAppender: appender,
                templateLock: props.templateLock === "none" ? false : (props.templateLock ?? false),
                template: props.template ? transformBlockTemplate(props.template) : undefined,
            });
            /**
             * A little bit experimental
             *
             * Adds support for headerTemplate/defaultBlocks/footerTemplate, which was first introduced in `_editor.tsx` for generate templates.
             */
            const blockId = inlineContext?.block[1].clientId;
            useEffect(() => {
                if (props.defaultBlocks || props.headerTemplate || props.footerTemplate) {
                    const newBlocks = applyTemplateBlocks(inlineContext?.innerBlocks ?? [], props);
                    wp.data.dispatch(wp.blockEditor.store).replaceInnerBlocks(blockId, newBlocks);
                }
            }, [
                hash(inlineContext?.innerBlocks.map((b) => [b.blockName, b.clientId])),
                hash([props.template, props.defaultBlocks, props.headerTemplate, props.footerTemplate]),
                blockId,
            ]);
            return (_jsx("div", { ...innerBlocksProps, className: [innerBlocksProps.className, props.adminClassName].filter(Boolean).join(" ") }));
        }
    }
    const blocks = useInnerBlocks();
    return _jsx(ContentBlocks, { blocks: blocks, spacer: props.spacer, wrapBlock: props.wrapBlock });
}
